import React from 'react';
import { Steps, Breadcrumb, Layout, notification, Modal } from 'antd/lib';
import * as Icons from '@ant-design/icons';
import { graphql, compose, withApollo } from 'react-apollo';

import Loading from '../../common/Loading';

import FormPersona from '../../tramites/formularios/FormPersona';
import FormDeclaracionJurada from '../../tramites/formularios/FormDeclaracionJurada';
import getDeclaracionJuradaPorId from '../../../graphql/querys/tramites/getDeclaracionJuradaPorId.graphql';
import insertPersona from '../../../graphql/mutations/persona/insertPersona.graphql';
import updateDeclaracionJurada from '../../../graphql/mutations/tramites/updateDeclaracionJurada.graphql';
import getDeclaracionesJuradas from '../../../graphql/querys/tramites/getDeclaracionesJuradas.graphql';
import getUsuario from '../../../graphql/querys/auth/getUsuario.graphql';
import { errorService } from '../../../graphql/utils/utils';

const estiloContent = {
  marginTop: 16,
  border: '1px dashed #e9e9e9',
  borderRadius: 6,
  backgroundColor: '#fafafa',
  paddingTop: 20,
};

@compose(
  graphql(insertPersona, {
    name: 'createPers',
  }),
  graphql(updateDeclaracionJurada, {
    name: 'updateDeclaracion',
    options: {
      refetchQueries: [{ query: getDeclaracionesJuradas }],
    },
  }),
  graphql(getUsuario)
)
class EditarDeclaracionJurada extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      declarante: {},
      certificacion: {},
      ente_receptor: '',
      declaracion: '',
      fecha_creacion: '',
      step: 0,
      guardado: false,
      loading: true,
    };

    this.props.client
      .query({
        query: getDeclaracionJuradaPorId,
        variables: { _id: this.props.match.params.id },
      })
      .then(res => {
        const declaracion = res.data.getDeclaracionJuradaPorId;
        // console.log("Respuesta exitosa!");
        // console.log(declaracion);

        this.setState({
          loading: false,
          declarante: declaracion.declarante,
          ente_receptor: declaracion.ente_receptor,
          declaracion: declaracion.declaracion,
          fecha_creacion: declaracion.fecha_creacion,
          _id: declaracion._id,
        });
      })
      .catch(err => {
        console.log('Error en la creacion');
        console.log(err);
        errorService(err, {
          _id: this.props.match.params.id,
        });
        Modal.error({
          title: 'Error en la inicializacion del componente grafico',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      });

    this.guardarPersona = this.guardarPersona.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.guardarDatosDeclaracion = this.guardarDatosDeclaracion.bind(this);
  }

  guardarPersona(persona) {
    // console.log(persona);
    this.setState(
      {
        declarante: {
          ...this.state.declarante,
          ...persona,
        },
      },
      function() {
        this.siguientePaso();
      }
    );
  }

  guardarDatosDeclaracion(datos) {
    // console.log("Editar cert: ");
    // console.log(datos);

    //Actualizamos la persona si es que existe, o la insertamos si creo una nueva.
    //Todo esto gracias al upsert en mongoDB.

    //Armamos una copia del objeto persona, y le sacmaos la propiedad __typename para que sea del tipo "InputPersona" de graphql
    let copiaPersona = this.state.declarante;
    delete copiaPersona.__typename;
    delete copiaPersona.fecha_ultimo_cambio;

    this.props
      .createPers({
        variables: { persona: copiaPersona },
      })
      .then(res => {
        let persona = res.data.insertPersona;
        // console.log("la respuesta es...");
        // console.log(res);

        let nuevaDeclaracion_Jurada = {
          declaracion: datos.declaracion,
          fecha_creacion: this.state.fecha_creacion,
          idDeclarante: persona._id,
          ente_receptor: datos.ente_receptor,
          idOrganismo: this.props.data.getUsuario.organismo._id,
        };

        // console.log("Paseeeeeeee");
        // console.log(this.state._id);

        this.props
          .updateDeclaracion({
            variables: {
              _id: this.state._id,
              nuevaDeclaracionJurada: nuevaDeclaracion_Jurada,
            },
          })
          // eslint-disable-next-line no-unused-vars
          .then(resDeclaracion => {
            notification.success({
              message: 'Actualizacion Correcta',
              description:
                'Se ha registrado los nuevos datos de la declaracion jurada',
            });

            this.props.history.push('/');
          });
      })
      .catch(err => {
        console.log('Error en la actualizacion de la declaracion jurada');
        console.log(err);

        Modal.error({
          title: 'Error en la actualizacion de la declaracion jurada',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      });
  }

  onCancel() {
    this.setState({
      fase: 0,
    });
  }

  siguientePaso() {
    let paso = this.state.step;
    paso++;
    this.setState({
      ...this.state,
      step: paso,
    });
  }

  anteriorPaso() {
    let paso = this.state.step;
    if (paso > 0) {
      paso--;
      this.setState({
        ...this.state,
        step: paso,
      });
    }
  }

  render() {
    if (this.state.loading) {
      return <Loading />;
    }

    const { Step } = Steps;
    let { step } = this.state;
    return (
      <div>
        <Breadcrumb
          style={{
            margin: '12px 0',
          }}
        >
          <Breadcrumb.Item>Declaracion Jurada</Breadcrumb.Item>
          <Breadcrumb.Item>Editar</Breadcrumb.Item>
        </Breadcrumb>
        <Layout
          style={{
            background: '#fff',
            padding: 24,
            minHeight: '80vh',
          }}
        >
          <h2 style={{ marginBottom: 10, textAlign: 'center' }}>
            <Icons.FileTextOutlined /> Editar Declaracion Jurada
          </h2>
          <br />
          <Steps className="stepsFormularios" current={step}>
            <Step title="Datos Persona" />
            <Step title="Datos de la Declaracion Jurada" />
          </Steps>
          <div style={estiloContent}>
            {step === 0 && (
              <FormPersona
                className="formularios"
                onSubmit={this.guardarPersona}
                onAnterior={() => this.props.history.goBack()}
                persona={this.state.declarante}
              />
            )}
            {step === 1 && (
              <FormDeclaracionJurada
                onSubmit={this.guardarDatosDeclaracion}
                datos={{
                  ente_receptor: this.state.ente_receptor,
                  declaracion: this.state.declaracion,
                }}
                config={{ creacion: false }}
              />
            )}
          </div>
        </Layout>
      </div>
    );
  }
}

export default withApollo(EditarDeclaracionJurada);
